import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { numberFormat } from "../../utils/helpers";
import PropTypes from "prop-types";

function ClaimPaymentTransactions({ row }) {
    const getPaymentName = (item) =>
        item.ClaimPaymentName || item.ComponentDescription || "";

    const getPaymentAmount = (item) =>
        item.ClaimPaymentAmt || item.ComponentPaymentAmount || null;

    function ClaimPaymentMapping(item) {
        return (
            <div className="row m-0">
                <div className="col-lg-6 col-6 text-right mb-10p">
                    {numberFormat(getPaymentAmount(item))}
                </div>
                <div className="col-lg-6 col-6 mb-10p">
                    {getPaymentName(item)}
                </div>
            </div>
        );
    }

    return (
        <div
            className=" w-100"
            style={{
                backgroundColor: "#E6F2F8",
            }}
        >
            <PerfectScrollbar style={{ height: "auto" }}>
                {row.original.PaymentAmountStatus.filter(
                    (item) => getPaymentName(item) === "Basic Benefit"
                ).map((item) => {
                    return ClaimPaymentMapping(item);
                })}

                {row.original.PaymentAmountStatus.filter(
                    (item) => getPaymentName(item) !== "Basic Benefit"
                ).map((item) => {
                    return ClaimPaymentMapping(item);
                })}
            </PerfectScrollbar>
        </div>
    );
}

ClaimPaymentTransactions.propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            PaymentAmountStatus: PropTypes.array.isRequired
        }).isRequired
    }).isRequired
};

export default ClaimPaymentTransactions;
